<ng-container *ngIf="link">
    <svg:path class="link" [ngStyle]="{stroke: linkColor, 'stroke-width': linkWidth}" [ngClass]="linkDash"
        [attr.d]="linkPath" (click)="onLinkClick()">
    </svg:path>
    <svg:path class="link-transparent" [attr.d]="linkPath" (click)="onLinkClick()"></svg:path>
</ng-container>